import { compose, withHandlers, withProps, withState } from 'recompose'

import platform from 'components/Trackers/platform'
import { WithFlowRouterProps, withFlowRouter } from 'utils/FlowProvider'
import { FlowRoute } from 'utils/FlowProvider/types'

import { Props } from './types'

type InnerProps = Props & WithFlowRouterProps

export const enhance = compose<InnerProps, {}>(
  withFlowRouter,
  withState('videoModalOpen', 'setVideoModalOpen', false),
  withHandlers<Partial<InnerProps>, {}>({
    getStartedOnPress: ({ route }) => () => {
      route({ from: FlowRoute.Welcome, action: 'continue', forwardQueryParams: true })
    },
    toggleVideo: ({ setVideoModalOpen, videoModalOpen }) => () => {
      setVideoModalOpen(!videoModalOpen)
    },
  }),
  withProps(() => {
    return {
      videoSrc:
        platform === 'desktop'
          ? 'https://assets.acorns.com/videos/Spend+Web/spend_promo_16-9.mp4'
          : 'https://assets.acorns.com/videos/spend/spend_promo_9-16.mp4',
    }
  }),
)
